export default "__VITE_ASSET__da6b5861__"